// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-page {
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.license-card {
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 8px;
  padding: 20px 24px;
}
.license-card h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 700;
}
.license-card__desc {
  margin: 0 0 16px;
  font-size: 13px;
  opacity: 0.7;
  line-height: 1.6;
}
.license-card__refresh {
  margin-left: auto;
}
.license-card__serverid {
  display: flex;
  align-items: center;
  gap: 12px;
}
.license-card__serverid code {
  flex: 1 1;
  padding: 12px 16px;
  border-radius: 6px;
  background: rgba(128, 128, 128, 0.12);
  font-family: monospace;
  font-size: 16px;
  letter-spacing: 2px;
  -webkit-user-select: all;
          user-select: all;
  word-break: break-all;
}

.license-fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
  margin: 0;
  padding-top: 12px;
  border-top: 1px solid rgba(128, 128, 128, 0.15);
}
.license-fields dt {
  font-size: 12px;
  opacity: 0.6;
  margin-bottom: 4px;
}
.license-fields dd {
  margin: 0;
  font-size: 14px;
  word-break: break-all;
}

.license-readonly {
  margin-top: 16px;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #ffa39e;
  background: rgba(255, 77, 79, 0.08);
  color: #cf1322;
  font-size: 13px;
  line-height: 1.6;
}

.license-key-input {
  font-family: monospace;
  font-size: 12px;
}

.license-activate-btn {
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/pages/License/LicenseStyled.scss"],"names":[],"mappings":"AAAA;EAEE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,0CAAA;EACA,kBAAA;EACA,kBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAKE;EACE,iBAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJJ;AAMI;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EAEA,wBAAA;UAAA,gBAAA;EACA,qBAAA;AALN;;AAUA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,+CAAA;AAPF;AASE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AAPJ;AAUE;EACE,SAAA;EACA,eAAA;EACA,qBAAA;AARJ;;AAYA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,sBAAA;EACA,eAAA;AATF;;AAYA;EACE,gBAAA;AATF","sourcesContent":[".license-page {\n  // 위쪽 여백은 .page-title 의 margin 이 이미 만들어 주므로 여기서는 빼 둡니다.\n  padding: 0 24px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.license-card {\n  border: 1px solid rgba(128, 128, 128, 0.2);\n  border-radius: 8px;\n  padding: 20px 24px;\n\n  h3 {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 0 0 12px;\n    font-size: 16px;\n    font-weight: 700;\n  }\n\n  &__desc {\n    margin: 0 0 16px;\n    font-size: 13px;\n    opacity: 0.7;\n    line-height: 1.6;\n  }\n\n  // 새로고침 버튼은 제목 줄 오른쪽 끝으로 밀어냅니다.\n  &__refresh {\n    margin-left: auto;\n  }\n\n  &__serverid {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    code {\n      flex: 1;\n      padding: 12px 16px;\n      border-radius: 6px;\n      background: rgba(128, 128, 128, 0.12);\n      font-family: monospace;\n      font-size: 16px;\n      letter-spacing: 2px;\n      // 클립보드 권한이 없을 때 사용자가 한 번에 선택할 수 있게 합니다.\n      user-select: all;\n      word-break: break-all;\n    }\n  }\n}\n\n.license-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 16px;\n  margin: 0;\n  padding-top: 12px;\n  border-top: 1px solid rgba(128, 128, 128, 0.15);\n\n  dt {\n    font-size: 12px;\n    opacity: 0.6;\n    margin-bottom: 4px;\n  }\n\n  dd {\n    margin: 0;\n    font-size: 14px;\n    word-break: break-all;\n  }\n}\n\n.license-readonly {\n  margin-top: 16px;\n  padding: 10px 14px;\n  border-radius: 6px;\n  border: 1px solid #ffa39e;\n  background: rgba(255, 77, 79, 0.08);\n  color: #cf1322;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.license-key-input {\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.license-activate-btn {\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
